var r={DARK:"dark",LIGHT:"light"};export{r as MODE};
